import styled from '@emotion/styled';

const TileSubtitle = styled('div')({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
});

export default TileSubtitle;
